module.exports = __webpack_public_path__ + "static/malibu-zoom-422681a71a02a9ebbae85dae8129d573.jpg";